import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  ApproveWorkOrderProps,
  CreateWorkOrderProps,
  DetailProps,
  ForceFactorsProps,
  GetAllWorkOrderProps,
  GetArchivedWorkOrdersProps,
  GetInStatusWorkOrdersProps,
  GetPipelineFiltersProps,
  GetReportGraphsProps,
  GetTopWorkOrdersProps,
  GetWorkOrderProps,
  GetWorkOrdersParams,
  ReportPdfLink,
} from './types';

export const createWorkOrder = (
  data: FormData
): Promise<CreateWorkOrderProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const editWorkOrder = (
  id: number,
  data: FormData,
  updateCoordinate = false
): Promise<CreateWorkOrderProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}?force_coordinate_event=${updateCoordinate}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getArchivedWorkOrders = (
  page: number,
  size: number,
  search: string
): Promise<GetArchivedWorkOrdersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/archived?page=${page}&size=${size}&search_string=${search}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getPipelineFilters = (
  params: GetWorkOrdersParams
): Promise<GetPipelineFiltersProps> => {
  const { uf, city, licenseCompanyId } = params;
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  let url = `${baseUrl}/api/V1/work-orders/filters?`;

  const paramsUrl = [];

  if (uf) paramsUrl.push(`uf=${uf}`);
  if (city) paramsUrl.push(`city_name=${city}`);
  if (licenseCompanyId) paramsUrl.push(`worker_company_id=${licenseCompanyId}`);

  url += paramsUrl.join('&');

  return fetch(`${url}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAllWorkOrders = (
  params: GetWorkOrdersParams
): Promise<GetAllWorkOrderProps> => {
  const { search, uf, city, licenseCompanyId, startDate, endDate } = params;
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  let url = `${baseUrl}/api/V1/work-orders?`;

  const paramsUrl = [];

  if (search) paramsUrl.push(`search_string=${search}`);
  if (uf) paramsUrl.push(`uf=${uf}`);
  if (city) paramsUrl.push(`city_name=${city}`);
  if (licenseCompanyId) paramsUrl.push(`worker_company_id=${licenseCompanyId}`);
  if (startDate) paramsUrl.push(`start_date=${startDate}`);
  if (endDate) paramsUrl.push(`end_date=${endDate}`);

  url += paramsUrl.join('&');

  return fetch(`${url}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getTopWorkOrders = (): Promise<GetTopWorkOrdersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/top`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getWorkOrdersInStatus = (
  status: number,
  page: number,
  size: number,
  sortType: 'asc' | 'desc'
): Promise<GetInStatusWorkOrdersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/in-status/${status}?page=${page}&size=${size}&sort=${sortType}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const GetWorkOrder = (id: number): Promise<GetWorkOrderProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const CancelWorkOrder = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/cancel`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const ChangeStatus = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/status`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const PreviousStatus = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/previous-status`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const SendToPept = (
  id: number,
  observation: string
): Promise<DetailProps> => {
  const data = JSON.stringify({ observation });
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/pept`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const SendInvoiceAndReceipt = (
  id: number,
  data: FormData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/invoice-receipt`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const SendProofOfPayment = (
  id: number,
  data: FormData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/proof_of_payment`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const addGoogleMapsImagesWithPins = (
  id: number,
  data: FormData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/google-maps-images`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getReportPDF = (id: number): Promise<Uint8Array> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/report-pdf?inline=false`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error('Não foi possível carregar o relatório');
      }
      return response.arrayBuffer();
    })
    .then((buffer) => new Uint8Array(buffer))
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const getReportPDFLink = (id: number): Promise<ReportPdfLink> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/report-pdf?inline=true`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const ApproveWorkOrder = (
  id: number,
  data: ApproveWorkOrderProps
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/approve`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const sendGraphs = (
  id: number,
  data: FormData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/report-graphs`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const generateReportPDF = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/generate-report-pdf`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const UploadFacadeImage = (
  id: number,
  data: FormData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/facade-image`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const exportSample = (id: number): Promise<Response> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/samples-xlsx`,
    requestOptions
  ).then((response) => response);
};

export const deleteAllSample = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/samples`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const sendForceFactors = (
  id: number,
  data: ForceFactorsProps
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/work-orders/${id}/avm-info`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getReportGraphs = (id: number): Promise<GetReportGraphsProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/report-graphs`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
